import { render, staticRenderFns } from "./SkeletonOverview.vue?vue&type=template&id=0512b9b1&"
import script from "./SkeletonOverview.vue?vue&type=script&lang=js&"
export * from "./SkeletonOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SkeletonOverview.vue"
export default component.exports